unit Configuration;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WebForm.Core, XData.Web.Client, MainDataModule,
  System.Generics.Collections, SMX.XData.Utils, Sys.Return.Types, Vcl.Controls,
  Vcl.StdCtrls, WEBLib.CheckLst, WEBLib.StdCtrls, WEBLib.ExtCtrls,
  WEBLib.TreeNodes, Vcl.ComCtrls, WEBLib.ComCtrls;

type
  TBranchClass = class
  private
    FName: string;
    FId: string;
  public
    property Name: string read FName write FName;
    property Id: string read FId write FId;
  end;

  TConfigurationForm = class(TCoreWebForm)
    CloseButton: TButton;
    SaveButton: TButton;
    WebPanel1: TPanel;
    RegionTV: TTreeView;
    BranchTV: TTreeView;
    MetricsCL: TCheckListBox;
    BranchListTimer: TTimer;
    procedure WebFormShow(Sender: TObject);
    procedure CloseButtonClick(Sender: TObject);
    procedure SaveButtonClick(Sender: TObject);
    procedure RegionTVClickCheckBox(Sender: TObject; ANode: TTreeNode;
      AState: Boolean);
    procedure BranchListTimerTimer(Sender: TObject);
    procedure WebFormDestroy(Sender: TObject);
    procedure BranchTVClickCheckBox(Sender: TObject; ANode: TTreeNode;
      AState: Boolean);
  private
    FGroupList: TStringList;
    FBranchList: TStringList;
    FBranchListForSelection: TStringList;
    FUserBranchList: TArray<string>;
    FDefaultBranchIds: string;
    FCompleteBranchList: TStringList;
    FNodeBranchIds: TStringList;
    FDashboardItemTitles: TList<TDashboardItemTitle>;
    FSavedDashboardItemTitles: TList<TDashboardItemTitle>;

    procedure SetBranchStructure(ABranchStructure: string);
    procedure PopulateGroupedBranchTree;
    procedure PopulateMetricsCheckList;
    procedure CollectSelectedMetrics;
    procedure FreeDashboardItemTitles;
    procedure SortMetricsForDisplay;
    function BranchAlreadyListed(const ABranchId: string): Boolean;
    function IsBranchChecked(ABranchId: string): Boolean;
    procedure SetUserBranchList(ABranchList: TArray<string>);
    procedure ApplyDefaultBranchSelection;
    procedure CollectSelectedBranchIds;
    procedure FreeBranchLists;
    procedure ApplyConfigurationListLayout;
    function BuildBranchCatalogJson: string;
    procedure ApplyBranchCheckboxBindings;
    procedure RegisterBranchNode(ANode: TTreeNode; const ABranchId: string);
    function NormalizeBranchId(const ABranchId: string): string;
    function BranchIdForNode(ANode: TTreeNode): string;
    procedure UpdateBranchSelectionById(const ABranchId: string; ASelected: Boolean);
  public
    procedure InitialiseConfig;
    procedure RefreshBranchList;
    procedure SetDashboardMetrics(ADashboardItemTitles: TList<TDashboardItemTitle>);
    function ExtractSavedDashboardItemTitles: TList<TDashboardItemTitle>;
    property BranchStructure: string write SetBranchStructure;
    property UserBranchList: TArray<string> read FUserBranchList write SetUserBranchList;
    property DefaultBranchIds: string read FDefaultBranchIds write FDefaultBranchIds;
  protected procedure LoadDFMValues; override; end;

var
  ConfigurationForm: TConfigurationForm;

implementation

{$R *.dfm}

{ TConfigurationForm }

procedure TConfigurationForm.FreeBranchLists;
var
  lIdx: Integer;
  lSubList: TStringList;
  lBranch: TBranchClass;
begin
  if Assigned(FCompleteBranchList) then
  begin
    for lIdx := 0 to FCompleteBranchList.Count - 1 do
    begin
      lBranch := TBranchClass(FCompleteBranchList.Objects[lIdx]);
      lBranch.Free;
    end;
    FCompleteBranchList.Free;
    FCompleteBranchList := nil;
  end;

  if Assigned(FBranchList) then
  begin
    for lIdx := 0 to FBranchList.Count - 1 do
    begin
      lSubList := TStringList(FBranchList.Objects[lIdx]);
      // Objects owned by FCompleteBranchList — clear refs only
      lSubList.Clear;
      lSubList.Free;
    end;
    FBranchList.Free;
    FBranchList := nil;
  end;

  if Assigned(FGroupList) then
  begin
    FGroupList.Free;
    FGroupList := nil;
  end;

  if Assigned(FBranchListForSelection) then
  begin
    FBranchListForSelection.Free;
    FBranchListForSelection := nil;
  end;

  if Assigned(FNodeBranchIds) then
  begin
    FNodeBranchIds.Free;
    FNodeBranchIds := nil;
  end;
end;

procedure TConfigurationForm.WebFormDestroy(Sender: TObject);
var
  lIdx: Integer;
  lItem: TDashboardItemTitle;
begin
  asm
    if (window.SMX && window.SMX.teardownConfigurationBranchCheckboxes) {
      window.SMX.teardownConfigurationBranchCheckboxes();
    }
  end;
  FreeBranchLists;
  FreeDashboardItemTitles;
  if Assigned(FSavedDashboardItemTitles) then
  begin
    for lIdx := 0 to FSavedDashboardItemTitles.Count - 1 do
    begin
      lItem := FSavedDashboardItemTitles[lIdx];
      lItem.Free;
    end;
    FSavedDashboardItemTitles.Free;
    FSavedDashboardItemTitles := nil;
  end;
  inherited;
end;

procedure TConfigurationForm.WebFormShow(Sender: TObject);
begin
  inherited;
  if not Assigned(FCompleteBranchList) then
    FCompleteBranchList := TStringList.Create;

  RegionTV.Visible := False;
  InitialiseConfig;
  ApplyConfigurationListLayout;
end;

function TConfigurationForm.NormalizeBranchId(const ABranchId: string): string;
var
  lValue: Double;
begin
  Result := Trim(ABranchId);
  if Result = '' then
    Exit;
  lValue := StrToFloatDef(Result, -1);
  if lValue <= 0 then
    Result := ''
  else
    Result := IntToStr(Trunc(lValue));
end;

procedure TConfigurationForm.ApplyConfigurationListLayout;
begin
  asm
    if (window.SMX && window.SMX.applyConfigurationListLayout) {
      window.SMX.applyConfigurationListLayout();
    }
  end;
end;

procedure TConfigurationForm.BranchListTimerTimer(Sender: TObject);
begin
  BranchListTimer.Enabled := False;
  RefreshBranchList;
end;

procedure TConfigurationForm.BranchTVClickCheckBox(Sender: TObject;
  ANode: TTreeNode; AState: Boolean);
var
  lBranchClass: TBranchClass;
  lBranchId: string;
begin
  inherited;
  lBranchId := BranchIdForNode(ANode);
  if lBranchId = '' then
    Exit;
  UpdateBranchSelectionById(lBranchId, AState);
  BranchTV.Selected := nil;
  ApplyConfigurationListLayout;
end;

procedure TConfigurationForm.CloseButtonClick(Sender: TObject);
begin
  inherited;
  ModalResult := mrClose;
end;

procedure TConfigurationForm.SaveButtonClick(Sender: TObject);
begin
  CollectSelectedBranchIds;
  CollectSelectedMetrics;
  ModalResult := mrOk;
end;

procedure TConfigurationForm.FreeDashboardItemTitles;
var
  lIdx: Integer;
  lItem: TDashboardItemTitle;
begin
  if not Assigned(FDashboardItemTitles) then
    Exit;

  for lIdx := 0 to FDashboardItemTitles.Count - 1 do
  begin
    lItem := FDashboardItemTitles[lIdx];
    lItem.Free;
  end;
  FDashboardItemTitles.Free;
  FDashboardItemTitles := nil;
end;

procedure TConfigurationForm.SetDashboardMetrics(ADashboardItemTitles: TList<TDashboardItemTitle>);
var
  lIdx: Integer;
  lCopy: TDashboardItemTitle;
begin
  FreeDashboardItemTitles;
  FDashboardItemTitles := TList<TDashboardItemTitle>.Create;

  if Assigned(ADashboardItemTitles) then
    for lIdx := 0 to ADashboardItemTitles.Count - 1 do
    begin
      lCopy := TDashboardItemTitle.Create;
      lCopy.Id := ADashboardItemTitles[lIdx].Id;
      lCopy.Title := ADashboardItemTitles[lIdx].Title;
      lCopy.Selected := ADashboardItemTitles[lIdx].Selected;
      lCopy.OrderIndex := ADashboardItemTitles[lIdx].OrderIndex;
      FDashboardItemTitles.Add(lCopy);
    end;

  SortMetricsForDisplay;
  PopulateMetricsCheckList;
end;

procedure TConfigurationForm.SortMetricsForDisplay;
var
  lIdx: Integer;
  lJdx: Integer;
  lItem: TDashboardItemTitle;
  lRankI: Integer;
  lRankJ: Integer;

  function ItemRank(const AItem: TDashboardItemTitle): Integer;
  begin
    if AItem.Selected then
    begin
      if AItem.OrderIndex > 0 then
        Result := AItem.OrderIndex
      else
        Result := 100000;
    end
    else
      Result := 200000;
  end;

begin
  if not Assigned(FDashboardItemTitles) or (FDashboardItemTitles.Count < 2) then
    Exit;

  for lIdx := 0 to FDashboardItemTitles.Count - 2 do
    for lJdx := lIdx + 1 to FDashboardItemTitles.Count - 1 do
    begin
      lRankI := ItemRank(FDashboardItemTitles[lIdx]);
      lRankJ := ItemRank(FDashboardItemTitles[lJdx]);

      if (lRankJ < lRankI) or
         ((lRankJ = lRankI) and (CompareText(FDashboardItemTitles[lJdx].Title,
           FDashboardItemTitles[lIdx].Title) < 0)) then
      begin
        lItem := FDashboardItemTitles[lIdx];
        FDashboardItemTitles[lIdx] := FDashboardItemTitles[lJdx];
        FDashboardItemTitles[lJdx] := lItem;
      end;
    end;
end;

procedure TConfigurationForm.PopulateMetricsCheckList;
var
  lIdx: Integer;
  lItem: TDashboardItemTitle;
  lHasSelected: Boolean;
begin
  MetricsCL.Items.Clear;
  if not Assigned(FDashboardItemTitles) then
    Exit;

  lHasSelected := False;
  for lIdx := 0 to FDashboardItemTitles.Count - 1 do
    if FDashboardItemTitles[lIdx].Selected then
    begin
      lHasSelected := True;
      Break;
    end;

  for lIdx := 0 to FDashboardItemTitles.Count - 1 do
  begin
    lItem := FDashboardItemTitles[lIdx];
    MetricsCL.Items.Add(lItem.Title);
    if lHasSelected then
      MetricsCL.Checked[lIdx] := lItem.Selected
    else
      MetricsCL.Checked[lIdx] := True;
  end;
  ApplyConfigurationListLayout;
end;

procedure TConfigurationForm.CollectSelectedMetrics;
var
  lIdx: Integer;
  lOrder: Integer;
  lSrc: TDashboardItemTitle;
  lItem: TDashboardItemTitle;
  lSelected: TList<TDashboardItemTitle>;
  lSortIdx: Integer;
  lSortJdx: Integer;
  lSwap: TDashboardItemTitle;
  lRankI: Integer;
  lRankJ: Integer;
  lMetricCount: Integer;
  lIsChecked: Boolean;
begin
  if Assigned(FSavedDashboardItemTitles) then
  begin
    for lIdx := 0 to FSavedDashboardItemTitles.Count - 1 do
    begin
      lItem := FSavedDashboardItemTitles[lIdx];
      lItem.Free;
    end;
    FSavedDashboardItemTitles.Free;
  end;

  FSavedDashboardItemTitles := TList<TDashboardItemTitle>.Create;
  if not Assigned(FDashboardItemTitles) then
    Exit;

  lMetricCount := MetricsCL.Items.Count;
  if (lMetricCount <= 0) or (lMetricCount <> FDashboardItemTitles.Count) then
    lMetricCount := FDashboardItemTitles.Count;

  lSelected := TList<TDashboardItemTitle>.Create;
  try
    for lIdx := 0 to lMetricCount - 1 do
    begin
      if lIdx >= FDashboardItemTitles.Count then
        Break;

      lSrc := FDashboardItemTitles[lIdx];
      lIsChecked := False;
      if lIdx < MetricsCL.Items.Count then
        lIsChecked := MetricsCL.Checked[lIdx];

      if lIsChecked then
        lSelected.Add(lSrc);
    end;

    for lSortIdx := 0 to lSelected.Count - 2 do
      for lSortJdx := lSortIdx + 1 to lSelected.Count - 1 do
      begin
        if lSelected[lSortIdx].OrderIndex > 0 then
          lRankI := lSelected[lSortIdx].OrderIndex
        else
          lRankI := 100000;
        if lSelected[lSortJdx].OrderIndex > 0 then
          lRankJ := lSelected[lSortJdx].OrderIndex
        else
          lRankJ := 100000;

        if (lRankJ < lRankI) or
           ((lRankJ = lRankI) and (CompareText(lSelected[lSortJdx].Title,
             lSelected[lSortIdx].Title) < 0)) then
        begin
          lSwap := lSelected[lSortIdx];
          lSelected[lSortIdx] := lSelected[lSortJdx];
          lSelected[lSortJdx] := lSwap;
        end;
      end;

    for lIdx := 0 to FDashboardItemTitles.Count - 1 do
    begin
      lSrc := FDashboardItemTitles[lIdx];
      lItem := TDashboardItemTitle.Create;
      lItem.Id := lSrc.Id;
      lItem.Title := lSrc.Title;
      if lIdx < MetricsCL.Items.Count then
        lItem.Selected := MetricsCL.Checked[lIdx]
      else
        lItem.Selected := False;
      lItem.OrderIndex := 0;
      FSavedDashboardItemTitles.Add(lItem);
    end;

    lOrder := 0;
    for lSortIdx := 0 to lSelected.Count - 1 do
    begin
      Inc(lOrder);
      for lIdx := 0 to FSavedDashboardItemTitles.Count - 1 do
      begin
        lItem := FSavedDashboardItemTitles[lIdx];
        if (lItem.Id = lSelected[lSortIdx].Id) and lItem.Selected then
        begin
          lItem.OrderIndex := lOrder;
          Break;
        end;
      end;
    end;
  finally
    lSelected.Free;
  end;
end;

function TConfigurationForm.ExtractSavedDashboardItemTitles: TList<TDashboardItemTitle>;
begin
  Result := FSavedDashboardItemTitles;
  FSavedDashboardItemTitles := nil;
end;

procedure TConfigurationForm.SetBranchStructure(ABranchStructure: string);
var
  lBranchStructure: string;
  lIdx: Integer;
  lIdx2: Integer;
  lRegionArray: JS.TJSArray;
  lGroupArray: JS.TJSArray;
  lBranchObj: JS.TJSObject;
  lRegionName: string;
  lBranchName: string;
  lBranchId: string;
  lSubBranch: TStringList;
  lBranchClass: TBranchClass;
begin
  if not Assigned(FGroupList) then
    FGroupList := TStringList.Create;
  if not Assigned(FBranchList) then
    FBranchList := TStringList.Create;
  if not Assigned(FCompleteBranchList) then
    FCompleteBranchList := TStringList.Create;
  if not Assigned(FNodeBranchIds) then
    FNodeBranchIds := TStringList.Create;

  RegionTV.Items.Clear;
  FGroupList.Clear;
  FNodeBranchIds.Clear;

  for lIdx := 0 to FBranchList.Count - 1 do
  begin
    lSubBranch := TStringList(FBranchList.Objects[lIdx]);
    lSubBranch.Clear;
    lSubBranch.Free;
  end;
  FBranchList.Clear;

  for lIdx := 0 to FCompleteBranchList.Count - 1 do
  begin
    lBranchClass := TBranchClass(FCompleteBranchList.Objects[lIdx]);
    lBranchClass.Free;
  end;
  FCompleteBranchList.Clear;

  lBranchStructure := Trim(ABranchStructure);
  if lBranchStructure = '' then
    Exit;

  lRegionArray := JS.toArray(TJSJSON.parse(lBranchStructure));

  for lIdx := 0 to lRegionArray.Length - 1 do
  begin
    lSubBranch := TStringList.Create;
    lGroupArray := JS.toArray(lRegionArray[lIdx]);
    if lGroupArray.Length = 0 then
    begin
      lSubBranch.Free;
      Continue;
    end;

    lRegionName := Trim(String(lGroupArray[0]));
    if lRegionName = '' then
      lRegionName := 'Ungrouped';

    FGroupList.Add(lRegionName);
    FBranchList.AddObject(lRegionName, lSubBranch);

    for lIdx2 := 1 to lGroupArray.Length - 1 do
    begin
      lBranchObj := JS.toObject(lGroupArray[lIdx2]);
      lBranchName := Trim(String(lBranchObj['BranchName']));
      lBranchId := Trim(String(lBranchObj['BranchId']));
      if (lBranchName = '') or (lBranchId = '') then
        Continue;

      if BranchAlreadyListed(lBranchId) then
        Continue;

      lBranchClass := TBranchClass.Create;
      lBranchClass.Name := lBranchName;
      lBranchClass.Id := lBranchId;
      lSubBranch.AddObject(lBranchName, lBranchClass);
      FCompleteBranchList.AddObject(lBranchName, lBranchClass);
    end;
  end;

  PopulateGroupedBranchTree;
end;

procedure TConfigurationForm.SetUserBranchList(ABranchList: TArray<string>);
begin
  FUserBranchList := ABranchList;
end;

procedure TConfigurationForm.ApplyDefaultBranchSelection;
var
  lParts: TArray<string>;
  lIdx: Integer;
  lCount: Integer;
  lPart: string;
begin
  if Length(FUserBranchList) > 0 then
    Exit;
  if Trim(FDefaultBranchIds) = '' then
    Exit;

  lParts := FDefaultBranchIds.Split([',']);
  lCount := 0;
  SetLength(FUserBranchList, 0);
  for lIdx := 0 to High(lParts) do
  begin
    lPart := Trim(lParts[lIdx]);
    if lPart = '' then
      Continue;
    SetLength(FUserBranchList, lCount + 1);
    FUserBranchList[lCount] := lPart;
    Inc(lCount);
  end;
end;

procedure TConfigurationForm.CollectSelectedBranchIds;
var
  lCatalogJson: string;
  lIdsJson: string;
  lIdArray: TJSArray;
  lIdx: Integer;
  lCount: Integer;
  lNewList: TArray<string>;
  lNode: TTreeNode;

  procedure AddBranchId(const ABranchId: string);
  var
    lCheckIdx: Integer;
    lNormalized: string;
  begin
    lNormalized := NormalizeBranchId(ABranchId);
    if lNormalized = '' then
      Exit;
    for lCheckIdx := 0 to lCount - 1 do
      if lNewList[lCheckIdx] = lNormalized then
        Exit;
    SetLength(lNewList, lCount + 1);
    lNewList[lCount] := lNormalized;
    Inc(lCount);
  end;

begin
  SetLength(lNewList, 0);
  lCount := 0;

  if Assigned(FNodeBranchIds) then
  begin
    for lIdx := 0 to FNodeBranchIds.Count - 1 do
    begin
      lNode := TTreeNode(FNodeBranchIds.Objects[lIdx]);
      if Assigned(lNode) and lNode.Checked then
        AddBranchId(FNodeBranchIds[lIdx]);
    end;
  end;

  if lCount = 0 then
  begin
    lCatalogJson := BuildBranchCatalogJson;
    lIdsJson := '[]';
    asm
      if (window.SMX && window.SMX.collectConfigurationBranchIds) {
        lIdsJson = window.SMX.collectConfigurationBranchIds(lCatalogJson);
      }
    end;

    if Trim(lIdsJson) <> '' then
    begin
      try
        lIdArray := TJSArray(TJSJSON.parse(lIdsJson));
        for lIdx := 0 to Trunc(lIdArray.Length) - 1 do
          AddBranchId(String(lIdArray[lIdx]));
      except
      end;
    end;
  end;

  FUserBranchList := lNewList;
end;

function TConfigurationForm.BuildBranchCatalogJson: string;
var
  lIdx: Integer;
  lBranchClass: TBranchClass;
  lBranchArray: TJSArray;
  lBranchObj: TJSObject;
begin
  Result := '[]';
  if not Assigned(FCompleteBranchList) or (FCompleteBranchList.Count = 0) then
    Exit;

  lBranchArray := TJSArray.new;
  for lIdx := 0 to FCompleteBranchList.Count - 1 do
  begin
    lBranchClass := TBranchClass(FCompleteBranchList.Objects[lIdx]);
    lBranchObj := TJSObject.new;
    lBranchObj['id'] := NormalizeBranchId(lBranchClass.Id);
    lBranchObj['name'] := lBranchClass.Name;
    lBranchArray.push(lBranchObj);
  end;
  Result := string(TJSJSON.stringify(lBranchArray));
end;

procedure TConfigurationForm.RegionTVClickCheckBox(Sender: TObject;
  ANode: TTreeNode; AState: Boolean);
var
  lRegionName: string;
  lRegionIndex: Integer;
  lBranchList: TStringList;
  lBranchIdx: Integer;
  lBranchClass: TBranchClass;
begin
  lRegionName := ANode.Text;
  lRegionIndex := FBranchList.IndexOf(lRegionName);
  if lRegionIndex >= 0 then
  begin
    lBranchList := TStringList(FBranchList.Objects[lRegionIndex]);
    for lBranchIdx := 0 to lBranchList.Count - 1 do
    begin
      lBranchClass := TBranchClass(lBranchList.Objects[lBranchIdx]);
      UpdateBranchSelectionById(lBranchClass.Id, AState);
    end;
  end;
  BranchListTimer.Enabled := True;
end;

procedure TConfigurationForm.RefreshBranchList;
begin
  PopulateGroupedBranchTree;
end;

procedure TConfigurationForm.InitialiseConfig;
begin
  if not Assigned(FBranchListForSelection) then
  begin
    FBranchListForSelection := TStringList.Create;
    FBranchListForSelection.Sorted := True;
  end;
end;

procedure TConfigurationForm.RegisterBranchNode(ANode: TTreeNode;
  const ABranchId: string);
var
  lNormalized: string;
begin
  if not Assigned(FNodeBranchIds) or not Assigned(ANode) then
    Exit;
  lNormalized := NormalizeBranchId(ABranchId);
  if lNormalized = '' then
    Exit;
  FNodeBranchIds.AddObject(lNormalized, ANode);
end;

procedure TConfigurationForm.PopulateGroupedBranchTree;
var
  lGroupIdx: Integer;
  lBranchIdx: Integer;
  lGroupName: string;
  lBranchList: TStringList;
  lGroupNode: TTreeNode;
  lBranchNode: TTreeNode;
  lBranchName: string;
  lBranchClass: TBranchClass;
begin
  if not Assigned(FNodeBranchIds) then
    FNodeBranchIds := TStringList.Create
  else
    FNodeBranchIds.Clear;

  BranchTV.BeginUpdate;
  try
    BranchTV.Items.Clear;
    for lGroupIdx := 0 to FBranchList.Count - 1 do
    begin
      lGroupName := FBranchList[lGroupIdx];
      lBranchList := TStringList(FBranchList.Objects[lGroupIdx]);
      if lBranchList.Count = 0 then
        Continue;

      lGroupNode := BranchTV.Items.Add(lGroupName);
      lGroupNode.Text := lGroupName;
      lGroupNode.Expanded := True;

      for lBranchIdx := 0 to lBranchList.Count - 1 do
      begin
        lBranchName := lBranchList[lBranchIdx];
        lBranchClass := TBranchClass(lBranchList.Objects[lBranchIdx]);
        lBranchNode := BranchTV.Items.AddChild(lGroupNode, lBranchName);
        lBranchNode.Text := lBranchName;
        lBranchNode.NodeType := ntCheckBox;
        lBranchNode.Checked := IsBranchChecked(lBranchClass.Id);
        RegisterBranchNode(lBranchNode, lBranchClass.Id);
      end;
    end;
  finally
    BranchTV.EndUpdate;
  end;

  BranchTV.Selected := nil;
  ApplyConfigurationListLayout;
  ApplyBranchCheckboxBindings;
end;

function TConfigurationForm.BranchIdForNode(ANode: TTreeNode): string;
var
  lIdx: Integer;
begin
  Result := '';
  if not Assigned(ANode) or not Assigned(FNodeBranchIds) then
    Exit;
  for lIdx := 0 to FNodeBranchIds.Count - 1 do
  begin
    if TTreeNode(FNodeBranchIds.Objects[lIdx]) = ANode then
      Exit(FNodeBranchIds[lIdx]);
  end;
end;

procedure TConfigurationForm.ApplyBranchCheckboxBindings;
var
  lBranchesJson: string;
begin
  lBranchesJson := BuildBranchCatalogJson;
  if lBranchesJson = '[]' then
    Exit;

  asm
    if (window.SMX && window.SMX.bindConfigurationBranchCheckboxes) {
      window.SMX.bindConfigurationBranchCheckboxes(this, lBranchesJson);
    }
  end;
end;

function TConfigurationForm.BranchAlreadyListed(const ABranchId: string): Boolean;
var
  lIdx: Integer;
  lBranchClass: TBranchClass;
  lNormalized: string;
begin
  Result := False;
  lNormalized := NormalizeBranchId(ABranchId);
  if lNormalized = '' then
    Exit;
  for lIdx := 0 to FCompleteBranchList.Count - 1 do
  begin
    lBranchClass := TBranchClass(FCompleteBranchList.Objects[lIdx]);
    if NormalizeBranchId(lBranchClass.Id) = lNormalized then
      Exit(True);
  end;
end;

function TConfigurationForm.IsBranchChecked(ABranchId: string): Boolean;
var
  lIdx: Integer;
  lBranchId: string;
  lNormalized: string;
begin
  Result := False;
  lNormalized := NormalizeBranchId(ABranchId);
  if lNormalized = '' then
    Exit;
  for lIdx := 0 to Length(FUserBranchList) - 1 do
  begin
    lBranchId := NormalizeBranchId(FUserBranchList[lIdx]);
    if lNormalized = lBranchId then
      Exit(True);
  end;
end;

procedure TConfigurationForm.UpdateBranchSelectionById(const ABranchId: string;
  ASelected: Boolean);
var
  lNormalizedId: string;
  lSelectedIdx: Integer;
  lSelectedCount: Integer;
  lShuffleIdx: Integer;
begin
  lNormalizedId := NormalizeBranchId(ABranchId);
  if lNormalizedId = '' then
    Exit;

  lSelectedCount := Length(FUserBranchList);

  if ASelected then
  begin
    if not IsBranchChecked(lNormalizedId) then
    begin
      SetLength(FUserBranchList, lSelectedCount + 1);
      FUserBranchList[lSelectedCount] := lNormalizedId;
    end;
    Exit;
  end;

  for lSelectedIdx := 0 to lSelectedCount - 1 do
  begin
    if NormalizeBranchId(FUserBranchList[lSelectedIdx]) = lNormalizedId then
    begin
      for lShuffleIdx := lSelectedIdx + 1 to lSelectedCount - 1 do
        FUserBranchList[lShuffleIdx - 1] := FUserBranchList[lShuffleIdx];
      SetLength(FUserBranchList, lSelectedCount - 1);
      Break;
    end;
  end;
end;

procedure TConfigurationForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  CloseButton := TButton.Create('CloseButton');
  SaveButton := TButton.Create('SaveButton');
  WebPanel1 := TPanel.Create('ConfigurationPanel');
  RegionTV := TTreeView.Create('RegionTV');
  BranchTV := TTreeView.Create('BranchTV');
  MetricsCL := TCheckListBox.Create('MetricsCL');
  BranchListTimer := TTimer.Create(Self);

  CloseButton.BeforeLoadDFMValues;
  SaveButton.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  RegionTV.BeforeLoadDFMValues;
  BranchTV.BeforeLoadDFMValues;
  MetricsCL.BeforeLoadDFMValues;
  BranchListTimer.BeforeLoadDFMValues;
  try
    Name := 'ConfigurationForm';
    ElementClassName := 'PopUpForm';
    SetEvent(Self, 'OnDestroy', 'WebFormDestroy');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    CloseButton.SetParentComponent(Self);
    CloseButton.Name := 'CloseButton';
    CloseButton.Left := 520;
    CloseButton.Top := 432;
    CloseButton.Width := 96;
    CloseButton.Height := 25;
    CloseButton.Caption := 'Close';
    CloseButton.ChildOrder := 2;
    CloseButton.HeightPercent := 100.000000000000000000;
    CloseButton.WidthPercent := 100.000000000000000000;
    SetEvent(CloseButton, Self, 'OnClick', 'CloseButtonClick');
    SaveButton.SetParentComponent(Self);
    SaveButton.Name := 'SaveButton';
    SaveButton.Left := 418;
    SaveButton.Top := 432;
    SaveButton.Width := 96;
    SaveButton.Height := 25;
    SaveButton.Caption := 'Save';
    SaveButton.ChildOrder := 2;
    SaveButton.HeightPercent := 100.000000000000000000;
    SaveButton.WidthPercent := 100.000000000000000000;
    SetEvent(SaveButton, Self, 'OnClick', 'SaveButtonClick');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 8;
    WebPanel1.Top := 8;
    WebPanel1.Width := 608;
    WebPanel1.Height := 401;
    WebPanel1.ChildOrder := 4;
    WebPanel1.TabOrder := 2;
    RegionTV.SetParentComponent(WebPanel1);
    RegionTV.Name := 'RegionTV';
    RegionTV.Left := 16;
    RegionTV.Top := 16;
    RegionTV.Width := 220;
    RegionTV.Height := 289;
    RegionTV.HeightPercent := 100.000000000000000000;
    RegionTV.WidthPercent := 100.000000000000000000;
    RegionTV.TabOrder := 0;
    RegionTV.TabStop := True;
    SetEvent(RegionTV, Self, 'OnClickCheckBox', 'RegionTVClickCheckBox');
    BranchTV.SetParentComponent(WebPanel1);
    BranchTV.Name := 'BranchTV';
    BranchTV.Left := 16;
    BranchTV.Top := 16;
    BranchTV.Width := 280;
    BranchTV.Height := 289;
    BranchTV.HeightPercent := 100.000000000000000000;
    BranchTV.WidthPercent := 100.000000000000000000;
    BranchTV.TabOrder := 1;
    BranchTV.TabStop := True;
    SetEvent(BranchTV, Self, 'OnClickCheckBox', 'BranchTVClickCheckBox');
    MetricsCL.SetParentComponent(WebPanel1);
    MetricsCL.Name := 'MetricsCL';
    MetricsCL.Left := 312;
    MetricsCL.Top := 16;
    MetricsCL.Width := 280;
    MetricsCL.Height := 289;
    MetricsCL.HeightPercent := 100.000000000000000000;
    MetricsCL.WidthPercent := 100.000000000000000000;
    MetricsCL.TabOrder := 2;
    MetricsCL.TabStop := True;
    BranchListTimer.SetParentComponent(Self);
    BranchListTimer.Name := 'BranchListTimer';
    BranchListTimer.Enabled := False;
    BranchListTimer.Interval := 100;
    SetEvent(BranchListTimer, Self, 'OnTimer', 'BranchListTimerTimer');
    BranchListTimer.Left := 56;
    BranchListTimer.Top := 424;
  finally
    CloseButton.AfterLoadDFMValues;
    SaveButton.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    RegionTV.AfterLoadDFMValues;
    BranchTV.AfterLoadDFMValues;
    MetricsCL.AfterLoadDFMValues;
    BranchListTimer.AfterLoadDFMValues;
  end;
end;

end.
